





































































































































































































import { Component} from 'vue-property-decorator';
import LegendUI from "@/components/map/LegendUI.vue";
import MapUI from "@/components/map/MapUI.vue";
import Print from "./print.class";

@Component({
  components: {
    'ol-map': MapUI,
    'v-legend': LegendUI
  }
})
export default class PrintGISagroMap extends Print {
}
